export const formatNumber = (value, options = {}) => {
  if (value === null || value === undefined) return "0";

  const num = Number(value);
  if (Number.isNaN(num)) return String(value);

  const {
    notationThreshold = 1000,
    maximumFractionDigits = 1,
    locale = "en",
  } = options;

  const useCompact = Math.abs(num) >= notationThreshold;

  try {
    return new Intl.NumberFormat(locale, {
      notation: useCompact ? "compact" : "standard",
      maximumFractionDigits: useCompact ? maximumFractionDigits : 0,
    }).format(num);
  } catch (error) {
    if (!useCompact) return num.toLocaleString();
    const suffixes = ["K", "M", "B", "T"];
    let scaled = num;
    let index = -1;

    while (Math.abs(scaled) >= 1000 && index < suffixes.length - 1) {
      scaled /= 1000;
      index += 1;
    }

    if (index === -1) return num.toLocaleString();
    const formatted = Number(scaled.toFixed(maximumFractionDigits));
    return `${formatted}${suffixes[index]}`;
  }
};
